import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'

dayjs.extend(customParseFormat)
dayjs.extend(utc)

/**
 * Parses dates in backend format 'YYYY-MM-DD HH:mm:ss UTC' (Safari-incompatible) to ISO string.
 */
export const parsePostDate = (dateStr: string): string => {
  if (dateStr?.endsWith(' UTC')) {
    const parsed = dayjs.utc(dateStr.replace(' UTC', ''), 'YYYY-MM-DD HH:mm:ss')
    if (parsed.isValid()) {
      return parsed.toISOString()
    }
  }
  return dayjs(dateStr).toISOString()
}

export const getSuggestedPostTime = (initialTime = dayjs()): dayjs.Dayjs => {
  const now = dayjs()
  const isToday = initialTime.isSame(now, 'day')

  if (!isToday) return initialTime.hour(12).minute(0).second(0).millisecond(0)

  const hoursToAdd = now.minute() >= 30 ? 2 : 1
  return now.add(hoursToAdd, 'hour').minute(0).second(0).millisecond(0)
}
